const labels = {
  assignment_id: 'Assignment', assignment_ids: 'Assignment', product_id: 'Product ID', product_ids: 'Product ID',
  sku: 'SKU', administrator_id: 'SA ID', administrator_name: 'SA name', administrator_email: 'SA email',
  internal_category: 'Category', group_code: 'Group', status: 'Status', source_event: 'Trigger',
  arrival_at: 'Arrival date', assigned_at: 'Assigned at', completed_at: 'Completed at',
  replaced_at: 'Replaced at', saved_at: 'Saved at', exported_at: 'Exported at',
  completed_by_id: 'Completed by ID', completed_by_name: 'Completed by', completed_by_email: 'Completed by email',
  replaced_by_assignment_id: 'Replacement assignment', replaced_by_product_id: 'Replacement product ID', replaced_by_sku: 'Replacement SKU',
  completion_source: 'Confirmation method', count: 'Item count', row_count: 'Row count',
  filters: 'Filter', q: 'Search', assignee_id: 'SA ID', from_date: 'From date', to_date: 'To date',
  administrator: 'Member', name: 'Name', email: 'Email', role: 'Role', member_role: 'Member role',
  active: 'Active access', capacity: 'Queue capacity', sort_order: 'Assignment order',
  in_queue_count: 'Pending upload count', last_assigned_at: 'Last assigned at', note: 'Note',
  deleted_at: 'Deleted at', deleted_by_name: 'Deleted by', deleted_by_email: 'Deleted by email',
  source_assignment_id: 'Source assignment', manual_action: 'Owner action',
  C: 'Category C', H: 'Category H', assignment_strategy: 'Assignment strategy'
}
const enums = { in_queue: 'ASSIGNED', done: 'ASSIGNED', assigned: 'ASSIGNED', replaced: 'REPLACED', assignee: 'SA', auditor: 'Auditor',
  detail_confirm_uploaded: 'Item detail page', bulk_checkbox: 'Bulk selection',
  initial_backfill: 'Initial queue population', appraisal_approved: 'Appraisal approved', reprice: 'Price change' }
export const auditDate = (value) => {
  const date = new Date(value)
  if (!value || Number.isNaN(date.getTime())) return '-'
  return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Asia/Jakarta' }).format(date)
}
const parse = (value) => {
  if (value === null || value === undefined || value === '') return {}
  if (typeof value === 'string') {
    try { return parse(JSON.parse(value)) } catch (_) { return { note: value } }
  }
  return typeof value === 'object' && !Array.isArray(value) ? value : { note: value }
}
const flatten = (data, prefix = '', result = {}) => {
  Object.entries(data).forEach(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key
    if (value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length) flatten(value, path, result)
    else result[path] = value
  })
  return result
}
const format = (value, key) => {
  if (value === null || value === undefined || value === '') return '-'
  if (value === true) return 'Yes'
  if (value === false) return 'No'
  if (Array.isArray(value)) return value.length ? value.map((v) => format(v, key.replace(/s$/, ''))).join(', ') : '-'
  if (typeof value === 'object') return Object.entries(value).map(([k, v]) => `${labels[k] || k}: ${format(v, k)}`).join('; ') || '-'
  if (key.endsWith('_at') && typeof value === 'string' && !Number.isNaN(Date.parse(value))) return `${auditDate(value)} WIB`
  if (key.includes('assignment') && /_id$/.test(key)) return `#${value}`
  return enums[value] || String(value)
}
export const auditDiff = (entry) => {
  const before = flatten(parse(entry.before)), after = flatten(parse(entry.after))
  const keys = Array.from(new Set([...Object.keys(before), ...Object.keys(after)]))
  const label = (key) => key.split('.').map((part) => labels[part] || part.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase())).join(' · ')
  const rows = (data) => Object.keys(data).map((key) => ({ key, label: label(key), value: format(data[key], key.split('.').pop()) }))
  return { before: rows(before), after: rows(after), changes: keys.filter((key) => JSON.stringify(before[key]) !== JSON.stringify(after[key]))
    .map((key) => ({ key, label: label(key), before: format(before[key], key.split('.').pop()), after: format(after[key], key.split('.').pop()) })) }
}
